import http from '../../../http'

const state = {
    messageList: [],
    top: 20
};

const mutations = {
    SET_MESSAGE_LIST: (state, payload) =>{
        state.messageList = payload;
    }
};

const actions = {
    getMessageList({commit, state}, payload) {
        let params = {};
        params.top = state.top;
        http.post('/supplier-resource/system/msg/messageList', params).then((res) => {
            if(res.data.code === '200') {
                commit('SET_MESSAGE_LIST',res.data.data);
            }
        });
    },
    readMessage({commit, state}, payload) {
        let params = {};
        params.accountId = payload.currentUser.id;
        params.msgId = payload.row.id;
        return new Promise((resolve) => {
            http.post('/supplier-resource/system/msg/readMessage', params).then((res) => {
                if (res.data.code === '200') {
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            });
        });
    },
    download({commit, state}, params) {
        http.post('/supplier-resource/system/fileUpload/isExist', params).then((res1) => {
            if(res1.data.code === '200') {
                http.request('/supplier-resource/system/fileUpload/download', 'get', 'blob', params).then((res) => {
                    if (res.status === 200) {
                        if (!res.data) {
                            return false;
                        } else {
                            const blob = res.data;
                            const contentDisposition = res.headers['content-disposition'];
                            let fileName = 'unknown';
                            if (contentDisposition) {
                                fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1]);
                            }
                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click(); // 点击下载
                            window.setTimeout(function () {
                                URL.revokeObjectURL(blob);
                                document.body.removeChild(link);
                            }, 0);
                        }
                    }
                }).catch((reason) => {
                    console.log(reason);
                });
            } else {
                //文件下载失败
            }
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
